import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { Observable, Subject } from 'rxjs';
import { ServiceordreService, ServiceAftaleService } from 'src/app/api/services';
import { Router } from '@angular/router';
import { KomponentTypeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-type-dto';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { GetServiceordrerResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/get-serviceordrer-response';
import { LogicService } from 'src/app/services/logic.service';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { OrdreService } from 'src/app/services/ordre.service';
import { OpgaveEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/opgave-enum';
import { ServiceaftaleStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-quickview',
    templateUrl: './quickview.component.html',
    styleUrls: ['./quickview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuickviewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() serviceaftale: ServiceaftaleDto;

  serviceOrdrer$: Observable<GetServiceordrerResponse>;
  komponentTyper: KomponentTypeDto[] = [];
  remarkToServicereport: string; // = 'Test af remarkToServicereport';
  today = new Date().toOkDateString();
  unsubscribe$ = new Subject<void>();
  canCreateEftersyn: boolean;
  canWrite: boolean = false;

  serviceaftaleStateEnum: typeof ServiceaftaleStateEnum = ServiceaftaleStateEnum;

  constructor(
    private serviceordreService: ServiceordreService,
    private serviceAftaleService: ServiceAftaleService,
    private router: Router,
    private errorHandler: ErrorHandlerService,
    private logic: LogicService,
    private ordreService: OrdreService,
    private auth: AuthService
  ) {
    this.canWrite = this.auth.canWrite;
  }

  ngOnInit(): void {
    this.canCreateEftersyn = this.logic.canCreateEftersyn(this.serviceaftale);
    this.serviceAftaleService.getAvailableKomponentTyper({ caller: EGIS_SERVICE_CALLER }).subscribe((data) => {
      this.komponentTyper = data;
    }),
      (error: HttpErrorResponse) => {
        this.errorHandler.HandleError(error);
      };
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  getKomponentType(komponentTypeId: number): string {
    let komponentType = this.komponentTyper.find((x) => x.id == komponentTypeId);
    return komponentType ? komponentType.text : '';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getAktiveServiceOrdrer(this.serviceaftale.serviceAftaleNo);
  }

  getAktiveServiceOrdrer(serviceaftaleNo: number) {
    this.serviceOrdrer$ = this.serviceordreService
      .getServiceordrer({
        caller: EGIS_SERVICE_CALLER,
        body: {
          serviceaftaleNoList: [serviceaftaleNo],
          serviceordreStateDtoIds: [1, 2, 3, 10, 12, 13],
        },
      })
      .pipe(
        tap((response: GetServiceordrerResponse) => {
          this.remarkToServicereport = null;
          for (var i = 0, len = response.serviceordrer.length; i < len; i++) {
            if (response.serviceordrer[i].serviceordreAfregning?.remarkToServicereport) {
              this.remarkToServicereport = response.serviceordrer[i].serviceordreAfregning.remarkToServicereport;
              break;
            }
            if (response.serviceordrer[i].afvistReturNote) {
              this.remarkToServicereport = response.serviceordrer[i].afvistReturNote;
              break;
            }
          }
        })
      );
  }

  getStatusIcon(serviceAftale: ServiceaftaleDto) {
    if (serviceAftale.isActive) return 'checkmark';
    //Created-pending vs notactive
    return serviceAftale.serviceaftaleState.state == ServiceaftaleStateEnum.CreatedPending ? 'watch' : 'ban';
  }

  getProductIcon(serviceAftale: ServiceaftaleDto) {
    return serviceAftale && serviceAftale.serviceAbonnement && serviceAftale.serviceAbonnement.product
      ? serviceAftale.serviceAbonnement.product.text.toLowerCase()
      : '';
  }

  createTilkald() {
    this.ordreService.create(OpgaveEnum.Tilkald, this.serviceaftale, null).subscribe(
      (serviceordre: ServiceordreDto) => {
        if (serviceordre) this.router.navigate(['/aftale', serviceordre.okKundeAftalenr], { fragment: 'Ordrer' });
      },
      (error) => {
        this.errorHandler.HandleError(error);
      }
    );
  }

  createOpstart() {
    this.ordreService.create(OpgaveEnum.Opstart, this.serviceaftale, null).subscribe(
      (serviceordre: ServiceordreDto) => {
        if (serviceordre) this.router.navigate(['/aftale', serviceordre.okKundeAftalenr], { fragment: 'Ordrer' });
      },
      (error) => {
        this.errorHandler.HandleError(error);
      }
    );
  }

  createEftersyn() {
    this.ordreService.create(OpgaveEnum.Eftersyn, this.serviceaftale, null).subscribe(
      (serviceordre: ServiceordreDto) => {
        if (serviceordre) this.router.navigate(['/aftale', serviceordre.okKundeAftalenr], { fragment: 'Ordrer' });
      },
      (error) => {
        this.errorHandler.HandleError(error);
      }
    );
  }

  isServiceaftaleTerminatedOrPendingTermination() {
    return (
      this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Terminated ||
      this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.ActivePendingTermination
    );
  }
}
